"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// document types
exports.default = {
    PASSPORT: 'PASSPORT',
    LICENSE: 'LICENSE',
    IQAMA: 'IQAMA',
    NATIONAL_ID: 'ID',
};
